export enum SemanticFieldSearchOperator {
  CONTAINS = 'CONTAINS',
  EQUALS = 'EQUALS',
  GREATER = 'GREATER',
  LESSER = 'LESSER',
  GREATER_OR_EQUAL = 'GREATER_OR_EQUAL',
  LESSER_OR_EQUAL = 'LESSER_OR_EQUAL',
  IN = 'IN',
}

export interface ISemanticFieldSearch {
  chiave?: string | null;
  operatore?: SemanticFieldSearchOperator;
  valore?:
    | string
    | number
    | boolean
    | null
    | undefined
    | Array<string | number | boolean | null | undefined>;
}
